export function registerHexagon(G6) {
    G6.registerNode('hexagon', {
        options: {
            style: {},
            stateStyles: {},
        },
        drawShape(cfg, group) {
            const [width, height] = (cfg.size || [130, 50]) as [number, number]

            const shapes = {
                keyShape: {
                    type: 'polygon',
                    attrs: {
                        fill: '#E8F1FF',
                        points: [
                            // 左顶点
                            [-width / 2, 0],
                            // 左上
                            [-width / 4, -height / 2],
                            // 右上
                            [width / 4, -height / 2],
                            // 右顶点
                            [width / 2, 0],
                            // 右下
                            [width / 4, height / 2],
                            // 左下
                            [-width / 4, height / 2]
                        ]
                    },
                }
            }

            const addShapes = {}

            let keyShape;
            Object.keys(shapes).forEach((shapeName) => {
                const { type, attrs } = shapes[shapeName]
                addShapes[shapeName] = group.addShape(type, {
                    attrs,
                    name: shapeName,
                    draggable: true,
                })

                if (shapeName === 'keyShape') {
                    keyShape = addShapes[shapeName]
                }
            })

            group.shapes = addShapes
            return keyShape
        },
    }, 'single-node')
}
